document.addEventListener("DOMContentLoaded", () => {
    try {
        const svgElement = document.querySelector("#svg-lines");
        if (svgElement) {
            setTimeout(() => {
                svgElement.classList.add('active');
            }, 50)
        }
    } catch (e) {console.log();}
});